export default "__VITE_ASSET__DMs0fVbg__"